import { useEffect, useState } from "react";
import {
    ListContainer,
    ListContext,
    PAGE_DEFAULT,
    PAGE_SIZE_UNLIMITED,
    Page,
    PageRoute,
    SearchBar,
    buildPath,
    buildTemplatePath,
    pn,
} from "@compass/core";
import { ListFooter } from "components";
import { FeederSchoolListDto, FeederSchoolListResource, ListFilterBase, Permission } from "generated/openApi";
import { useInitListFilter, useList } from "hooks";
import { Outlet } from "react-router-dom";
import ApiService from "services/apiService";
import { FeederSchoolListPageHeader } from "./FeederSchoolListPageHeader";
import { FeederSchoolTable } from "./FeederSchoolTable"; 


const routeName = "feederSchools";
export const feederSchoolListPageRoute: PageRoute = {
    handle: "Feeder Schools",
    templatePath: buildTemplatePath(routeName),
    getPath: () => buildPath(routeName),
};

export const FeederSchoolListPage = () => {
    const ROOT_PERMISSION: Permission = Permission.SystemUtility;

    const [listItems, setListItems] = useState<FeederSchoolListDto[]>([]);
    const [total, setTotal] = useState<number>();
    const [resource, setResource] = useState<FeederSchoolListResource>({});
    const [searchFocused, setSearchFocused] = useState<boolean>(false);

    const { listFilter, setListFilter } = useInitListFilter<ListFilterBase>({
        sortObjects: [{ property: pn<FeederSchoolListDto>("name"), isDesc: false }],
    });

    const { tableContainerRef, applyPage, applyPageSize, loadList, applySort, applySearch, applySortMethod } = useList({
        listFilter: listFilter,
        setListFilter: setListFilter,
        fetchList: (listFilter) => {
            ApiService.feederSchools.getList(listFilter).then((response) => {
                setListItems(response);
            });
        },
        fetchTotal: (listFilter) => {
            setTotal(undefined);
            ApiService.feederSchools.getListTotal(listFilter).then((response) => {
                setTotal(response);
            });
        },
    });

    useEffect(() => {
        loadList(listFilter);
        ApiService.feederSchools.getListResource().then((response) => {
            setResource(response);
        });
    }, []);

    return (
        <>
            <Page header={<FeederSchoolListPageHeader rootPermission={ROOT_PERMISSION} handle={feederSchoolListPageRoute.handle} />}>
                <ListContainer
                    fullHeight
                    header={<SearchBar onStoppedTyping={applySearch} setSearchFocused={setSearchFocused} size="small" />}
                    tableContainer={
                        <FeederSchoolTable
                            rootPermission={ROOT_PERMISSION}
                            tableContainerRef={tableContainerRef}
                            feederSchools={listItems}
                            setFeederSchools={setListItems}
                            resource={resource}
                            searchFocused={searchFocused}
                            sortObjects={listFilter.sortObjects}
                            sort={applySort}
                            loadList={() => loadList(listFilter)}
                        />
                    }
                    footer={
                        <ListFooter
                            total={total}
                            size={listFilter.pageSize}
                            page={listFilter.page}
                            onPageChange={applyPage}
                            onSizeChange={applyPageSize}
                            onSortMethodChange={applySortMethod}
                        />
                    }
                />
            </Page>
            <ListContext.Provider value={{ loadList: (options) => loadList(listFilter, { resetPage: options?.resetPage }) }}>
                <Outlet />
            </ListContext.Provider>
        </>
    );
};